<template>
  <div class="pay-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
              </div>

              <el-date-picker
                v-model="search.response_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :picker-options="!$store.getters.isPii ? $commonFn.dateLimit(this, 31) : undefined"
              />
            </div>

            <div v-if="$store.getters.isID" class="filter-item">
              <div class="filter-item-label">
                {{ $t('data.actual_settlement_time') }}
              </div>
              <el-date-picker
                v-model="search.settlement_time"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
                :default-time="['00:00:00', '23:59:59']"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchant.payment_channel') }}</div>
              <el-select v-model="search.channel_code" filterable class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in compFilterPaymentChannel"
                  :key="index"
                  :label="item.channel_code"
                  :value="item.channel_code"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.transaction_status') }}</div>
              <el-select v-model="search.transaction_status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in payTransactionStatusArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.settlement_status') }}</div>
              <el-select v-model="search.settlement_status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in transactionSettlementStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id') }}</div>
              <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}</div>
              <el-input v-model="search.merchant_order_id" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.reference_no') }}</div>
              <el-input v-model="search.channel_reference_no" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div v-if="!$store.getters.isID" class="filter-item">
              <div class="filter-item-label">{{ $t('checkout.checkout_order_id') }}</div>
              <el-input v-model="search.checkout_id" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div v-if="$store.getters.isPii" class="filter-item">
              <div class="filter-item-label">{{ $t('acceptPayments.static_qr_id') }}</div>
              <el-input v-model="search.qr_stand_no" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <div v-if="$store.getters.isPii" class="filter-item">
              <div class="filter-item-label">{{ $t('operation.business') }}</div>
              <ScopeSelect
                :value="search.business_id"
                class="filter-item-value"
                :is-remote="true"
                :http-request-method="searchBusinessOptions"
                :remote-params="getBusinessSearchParams"
                :option-label="formatBusinessOption"
                :select-placeholder="$t('operation.select_business')"
                @updateValue="search.business_id = $event"
              />
            </div>
            <div v-if="$store.getters.isPii" class="filter-item">
              <div class="filter-item-label">{{ $t('operation.franchisee') }}</div>
              <ScopeSelect
                :value="search.franchisee_id"
                class="filter-item-value"
                :is-remote="true"
                :http-request-method="searchFranchiseeOptions"
                :remote-params="getFranchiseeSearchParams"
                :option-label="formatFranchiseeOption"
                :select-placeholder="$t('operation.select_franchisee')"
                @updateValue="search.franchisee_id = $event"
              />
            </div>
            <div v-if="$store.getters.isPii" class="filter-item">
              <div class="filter-item-label" />
            </div>
            <div v-if="$store.getters.isID && compIsJTMerchant" class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchant.jt_institute_way_code') }}
              </div>
              <el-select v-model="search.jt_institute_way_code" filterable class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in jtInstituteWayCode"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-if="$store.getters.isMX" class="filter-item">
              <div class="filter-item-label">{{ $t('data.pos_machine_sn') }}</div>
              <el-input v-model="search.pay_data" size="small" type="text" class="filter-item-value" clearable />
            </div>
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>
    <div class="total-container">
      <div class="total-item">{{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">{{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_amount | toDivideWithDot }}</span>
      </div>
      <div class="total-item">{{ $t('data.total_fee') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_fee | toDivideWithDot }}</span>
      </div>

    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.reference_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_reference_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.payment_type')" align="center">
          <template slot-scope="scope">
            <span>{{ getproductCategoryMap( scope.row.product_category) }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPayTransStatusType(scope.row.transaction_status)">{{ getPayTransStatusLabel(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isMX" :label="$t('data.pos_machine_sn')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_data }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_fee && scope.row.payment_fee.fee_split | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('data.name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_name }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('data.mobile')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_info && scope.row.payment_info.payer_mobile }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column width="105" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time }}
          </template>
        </el-table-column>

        <el-table-column width="105" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isID && compIsJTMerchant" :label="$t('merchant.jt_institute_way_code')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.institute_way_code }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isPii" :label="$t('operation.business')" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="copyable-no" @click="copyNumber(getBusinessNo(scope.row))">{{ getBusinessNo(scope.row) }}</div>
            <div class="secondary-text">{{ getBusinessName(scope.row) }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isPii" :label="$t('operation.franchisee')" min-width="150" align="center">
          <template slot-scope="scope">
            <div class="copyable-no" @click="copyNumber(getFranchiseeNo(scope.row))">{{ getFranchiseeNo(scope.row) }}</div>
            <div class="secondary-text">{{ getFranchiseeName(scope.row) }}</div>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('data.remark')" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.remark || scope.row.remark.length<=10">{{ scope.row.remark }}</span>
            <el-tooltip v-else class="item" effect="light" :content="scope.row.remark" placement="top">
              <span class="show-ellipsis" style="cursor: pointer;display:inline-block;max-width: 100px;">{{ scope.row.remark }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center" min-width="100">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
            <el-tooltip v-if="store.getters.authorities.includes('AUTH_CODE_PAYMENT_REFUND')" placement="top">
              <div slot="content">
                <span v-if="[1,4,5,6,8,9].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_1') }} <br> </span>
                <span v-else-if="[2,3].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_2') }}<br> </span>
                <span v-else-if="[7].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_3') }}<br> </span>
                <span v-else> {{ $t('components.refund') }}<br> </span>
              </div>
              <svg-icon :class="{ 'is-disabled': !(scope.row.original_refund_status && scope.row.original_refund_status !== 1) }" class-name="icon-function" icon-class="refund-icon" @click="onClickRefundTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <payment-details-modal ref="paymentDetailsModal" :detail-id="detailId" />
    <payment-refund-modal ref="paymentRefundModal" :detail-id="detailId" @updatelist="handleFilter" />
  </div>
</template>

<script>

import { fetchPaymentDetailInfo, fetchPaymentDetailInfoAllList } from '@/api/settlement/settlement'
import { fetchPageMethodChannelList } from '@/api/components/components'
import { searchBusinesses } from '@/api/operation-manage/business'
import { searchFranchisees } from '@/api/operation-manage/franchisee'

import {
  payTransactionStatusMap,
  payTransactionStatusVoidMap,
  payTransactionTypeMap,
  productCategoryMap
} from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import store from '@/store'

export default {
  name: 'Pay_Trans_Details',
  components: {
    ScopeSelect: () => import('@/components/ScopeSelect'),
    Paginator: () => import('@/views/components/Paginator'),
    PaymentDetailsModal: () => import('./Modal/PayinDetailsModal'),
    PaymentRefundModal: () => import('./Modal/PayinRefundModal')
  },
  data() {
    this.jtInstituteWayCode = [
      {
        label: 'BCA',
        value: 'BCA'
      },
      {
        label: 'BNI',
        value: 'BNI'
      },
      {
        label: 'OTHERS',
        value: 'OTHERS'
      }
    ]
    this.TRANSACTION_STATUS = {
      void: 4
    }
    return {
      showFilterContent: true,
      search: {
        merchant_order_id: '',
        transaction_status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        response_times: [],
        settlement_time: [],
        channel_code: '',
        payment_code: '',
        transaction_id: '',
        payer_mobile: '',
        app_name: '',
        checkout_id: '',
        qr_stand_no: '',
        pay_data: '',
        business_id: '',
        franchisee_id: '',
        reference_no: ''
      },
      businessOptions: [],
      paymentMethodArr: [
        { label: 'Bill Payment', value: 2 },
        { label: 'QR Code', value: 1 },
        { label: 'Bank Transfer', value: 3 }
      ],
      payinChannelList: [],
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    store() {
      return store
    },
    payTransactionStatusArr() {
      // 目前只有泰国有撤销
      const payTransactionStatusArr = payTransactionStatusMap()
      const queryPayTransactionStatusVoidArr = payTransactionStatusVoidMap()
      return this.$store.getters.curCountry.country_code === 'TH' ? queryPayTransactionStatusVoidArr : payTransactionStatusArr
    },
    compFilterPaymentChannel() {
      if (!this.search.pay_product_type) {
        return this.payinChannelList
      }
      const arr = this.payinChannelList.filter(item => item.payment_method === this.search.pay_product_type)
      return arr
    },
    getPayTransStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayTransStatusLabel() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransTypeMap() {
      return function(val) {
        return payTransactionTypeMap(val).label
      }
    },
    getPayTransTypeStyle() {
      return function(val) {
        return payTransactionTypeMap(val).type
      }
    },
    productCategoryMap() {
      const productCategories = productCategoryMap()
      return productCategories.filter(category => category.value !== 1)
    },
    getproductCategoryMap() {
      return function(value) {
        return productCategoryMap(value).label
      }
    },
    transactionSettlementStatusMap() {
      return transactionSettlementStatusMap()
    },
    compIsJTMerchant() {
      return this.$store.state.user.isJtMerchant
    }
  },
  created() {
    const { checkout_id, qrNo } = this.$route.query
    this.search.checkout_id = checkout_id
    this.search.qr_stand_no = qrNo
    this.getAllChannelList()
    this.handleFilter()
  },
  methods: {
    getAllChannelList() {
      // 按当前商户国家过滤支付渠道列表
      fetchPageMethodChannelList({ country_code: this.$store.getters.curCountry.country_code }).then(res => {
        this.payinChannelList = res.data || []
      })
    },
    searchFranchiseeOptions(params) {
      return searchFranchisees(params)
    },
    getFranchiseeSearchParams(keyword) {
      return { keyword, page_size: 20 }
    },
    formatFranchiseeOption(franchisee) {
      return [franchisee.franchisee_no, franchisee.franchisee_name].filter(Boolean).join(' / ')
    },
    searchBusinessOptions(params) {
      return searchBusinesses(params)
    },
    getBusinessSearchParams(keyword) {
      return { keyword, page_size: 20 }
    },
    formatBusinessOption(business) {
      return [business.business_no, business.business_name].filter(Boolean).join(' / ')
    },
    getOptionLabel(entityNo, entityName) {
      return [entityNo, entityName].filter(Boolean).join(' / ')
    },
    getBusinessNo(transaction) {
      return transaction.business_no || '-'
    },
    getBusinessName(transaction) {
      return transaction.business_name || '-'
    },
    getFranchiseeNo(transaction) {
      return transaction.franchisee_no || '-'
    },
    getFranchiseeName(transaction) {
      return transaction.franchisee_name || '-'
    },
    copyNumber(value) {
      if (!value || value === '-') return
      const input = document.createElement('textarea')
      input.value = value
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success(this.$t('operation.copy_success'))
    },
    getPaymentDetailInfo(params) {
      this.listLoading = true
      fetchPaymentDetailInfo(params).then(res => {
        // eslint-disable-next-line no-unused-vars
        const { total = 15, list = [], current = 1, total_amount, total_fee } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_fee = total_fee
        this.total_count = total
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { transaction_status, channel_code, times = [], response_times = [], settlement_time = [], merchant_order_id, transaction_id, payment_code, payer_mobile, app_name, reference_no, ...otherSearch } = this.search
      let params = {
        start_date_time: times && times[0],
        end_date_time: times && times[1],
        response_start_date_time: response_times && response_times[0],
        response_end_date_time: response_times && response_times[1],
        settlement_time_start: settlement_time && settlement_time[0],
        settlement_time_end: settlement_time && settlement_time[1],
        transaction_status,
        channel_code,
        transaction_country: this.$store.getters.curCountry.country_code,
        mch_order_id: merchant_order_id,
        transaction_id,
        payment_code,
        reference_no,
        payer_mobile,
        app_name,
        ...otherSearch,
        ...otherParams
      }
      if (payer_mobile && ((!times || times.length === 0) && (!response_times || response_times.length === 0))) {
        this.$message.warning('Pls input Transition Date')
        return null
      }
      params = filterEmptyAttr(params)
      return params
    },

    showPayDetailModal() {
      this.$refs.paymentDetailsModal.changModalStatus(true)
    },

    handleFilter(otherParams = {}) {
      if (!this.$store.getters.isPii) {
        if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 15)) {
          this.$message.warning('The maximum date range  is limited to 15 days, please select again')
          return
        }
        if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 15)) {
          this.$message.warning('The maximum date range  is limited to 15 days, please select again')
          return
        }
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.settlement_time, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentDetailInfo(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },

    onClickRefundTxt(row) {
      if ((row.original_refund_status && row.original_refund_status !== 1)) {
        this.detailId = row.transaction_id
        this.showPayRefundModal(row)
      }
    },

    showPayRefundModal(row) {
      this.$refs.paymentRefundModal.changModalStatus(true, row)
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickDowmloadBtn() {
      if (!this.$store.getters.isPii) {
        if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 31)) {
          this.$message.warning('The maximum date range  is limited to 31 days, please select again')
          return
        }
        if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 31)) {
          this.$message.warning('The maximum date range  is limited to 31 days, please select again')
          return
        }
      }
      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      fetchPaymentDetailInfoAllList(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Pay_Trans_Details')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const headers = [
        this.$t('customerService.transaction_id'),
        this.$t('customerService.reference_no'),
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('merchantAccount.transaction_amount'),
        this.$t('merchant.service_fee'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('merchantAccount.recipient_mobile'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchant.payment_channel'),
        // this.$t('merchantAccount.pay_trans_id'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]
      if (this.$store.getters.isPii) {
        headers.push(this.$t('operation.business_no_export'), this.$t('operation.business_name_export'), this.$t('operation.franchisee_no_export'), this.$t('operation.franchisee_name_export'))
      }
      const rows = [headers]

      // const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          const row = [
            tr.transaction_id,
            tr.reference_no,
            tr.merchant_order_id,
            tr.amount,
            tr.fee,
            tr.name,
            tr.mobile,
            tr.status,
            tr.payment_channel,
            // tr.transaction_id,
            tr.create_time,
            tr.complete_time
          ]
          if (this.$store.getters.isPii) {
            row.push(tr.business_no, tr.business_name, tr.franchisee_no, tr.franchisee_name)
          }
          rows.push(row)
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-trans-details{
  .copyable-no {
    color: #3855F1;
    cursor: pointer;
  }
  .secondary-text {
    margin-top: 4px;
    color: #606266;
  }
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.is-disabled:hover {
  color: #98A1B4;
}
</style>
